import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { MOLD_RECEIVING } from '../../constants/moldConstants';
const styles = {
  uploadContainer: {
    background: 'white',
    borderRadius: '4px',
    // padding: '15px',
  },
  uploadArea: {
    marginBottom: '15px',
  },
  uploadLabel: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '120px',
    border: '2px dashed #ccc',
    borderRadius: '4px',
    cursor: 'pointer',
    backgroundColor: '#f9f9f9',
    transition: 'background-color 0.2s',
  },
  uploadContent: {
    textAlign: 'center',
  },
  uploadIcon: {
    fontSize: '16px',
    color: '#666',
    marginBottom: '8px',
  },
  uploadText: {
    fontSize: '14px',
    color: '#666',
    marginBottom: '4px',
  },
  uploadBold: {
    fontWeight: 600,
  },
  uploadSubtext: {
    fontSize: '12px',
    color: '#888',
  },
  hiddenInput: {
    display: 'none',
  },
  previewGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))',
    // gap: '15px',
    marginTop: '15px',
    //   display: 'flex',
    //   gap: '10px',
    overflowX: 'auto',
    //   scrollBehavior: 'smooth',
    //   whiteSpace: 'nowrap',
    //   paddingBottom: '10px',
  },
  previewItem: {
    flex: '0 0 auto', // ✅ Ensures items don't shrink
    width: '150px',
    position: 'relative',
    borderRadius: '4px',
    // overflow: 'hidden',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
    // position: 'relative',
    // borderRadius: '4px',
    // overflow: 'hidden',
    // boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
  },
  previewImageContainer: {
    position: 'relative',
    paddingTop: '75%' /* 4:3 Aspect Ratio */,
  },
  previewImage: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  previewWrapper: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    width: '100%',
  },
  previewContainer: {
    display: 'flex',
    overflowX: 'auto', // ✅ Scrollbar will appear when needed
    whiteSpace: 'nowrap',
    gap: '10px',
    paddingBottom: '10px',
  },
  removeButton: {
    position: 'absolute',
    top: '8px',
    right: '8px',
    width: '20px',
    height: '20px',
    borderRadius: '50%',
    backgroundColor: '#ff4444',
    color: 'white',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '14px',
    opacity: 0,
    transition: 'opacity 0.2s',
  },
  fileName: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    padding: '6px 8px',
    fontSize: '12px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
};

const initData = {
  id: 0,
  fileName: '',
  filePath: '',
  relativePath: '',
};
const FileUpload = ({ onChange, value = [], acceptedTypes = [], maxSize }) => {
  const [isHovering, setIsHovering] = useState(false);
  const [safetyFiles, setSafetyFiles] = useState([]);

  useEffect(() => {
    if (Array.isArray(value) && value.length > 0) {
      setSafetyFiles(value);
    }
  }, []);

  const generateUniqueId = existingIds => {
    let newId;
    do {
      newId = Math.floor(Math.random() * 1000000);
    } while (existingIds.has(newId));
    return newId;
  };

  const handleFileUpload = async event => {
    const files = Array.from(event.target.files);
    let newFiles = safetyFiles;
    files.forEach(file => {
      if (file) {
        const existingIds = new Set(newFiles.map(file => file.id));
        const newFile = {
          id: generateUniqueId(existingIds),
          fileName: file.name,
          filePath: '', //result.filePath,
          relativePath: '', //result.relativePath,
          preview: URL.createObjectURL(file),
          file: file
        };
        newFiles = [...newFiles, newFile];
      }
    });
    setSafetyFiles(newFiles);
    onChange(newFiles);
  };

  const removeFile = fileId => {
    const newFiles = safetyFiles.filter(safetyFile => safetyFile.id !== fileId);
    setSafetyFiles(newFiles);
    onChange(newFiles);
  };

  return (
    <div style={styles.uploadContainer}>
      <div style={styles.uploadArea}>
        <label
          htmlFor="file-upload"
          style={{
            ...styles.uploadLabel,
            backgroundColor: isHovering ? '#f0f0f0' : '#f9f9f9',
          }}
          onMouseEnter={() => setIsHovering(true)}
          onMouseLeave={() => setIsHovering(false)}
        >
          <div style={styles.uploadContent}>
            <div style={styles.uploadIcon}>↑</div>
            <p style={styles.uploadText}>
              <span style={styles.uploadBold}>Click to upload</span> or drag and drop
            </p>
            <p style={styles.uploadSubtext}>PNG, JPG, GIF up to 10MB</p>
          </div>
          <input
            id="file-upload"
            type="file"
            style={styles.hiddenInput}
            accept={acceptedTypes.length ? acceptedTypes.join(',') : '*/*'}
            multiple
            onChange={handleFileUpload}
          />
        </label>
      </div>

      {safetyFiles.length > 0 && (
        <div style={styles.previewContainer}>
          {safetyFiles.map(file => (
            <div
              key={file.id}
              style={styles.previewItem}
              onMouseEnter={e => {
                const removeBtn = e.currentTarget.querySelector('.remove-btn');
                if (removeBtn) removeBtn.style.opacity = '1';
              }}
              onMouseLeave={e => {
                const removeBtn = e.currentTarget.querySelector('.remove-btn');
                if (removeBtn) removeBtn.style.opacity = '0';
              }}
            >
              <div style={styles.previewImageContainer}>
                <img
                  src={file.relativePath != '' ? file.relativePath : file.preview}
                  alt={file.fileName}
                  style={styles.previewImage}
                />
              </div>
              <button
                className="remove-btn"
                onClick={() => removeFile(file.id)}
                style={styles.removeButton}
                title="Remove file"
              >
                ×
              </button>
              <div style={styles.fileName}>{file.fileName}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

FileUpload.propTypes = {
  onChange: PropTypes.func.isRequired,
  acceptedTypes: PropTypes.arrayOf(PropTypes.string),
  maxSize: PropTypes.number,
  initialFiles: PropTypes.array,
};

FileUpload.defaultProps = {
  acceptedTypes: ['image/png', 'image/jpeg', 'image/gif'],
  maxSize: 10 * 1024 * 1024, // 10MB
};

export default FileUpload;
